import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Наименование", -1)
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Тип", -1)
const _hoisted_5 = { class: "col-6 ModelField-colLast" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Перечисление", -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Динамический справочник", -1)
const _hoisted_10 = { key: 2 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Справочник", -1)
const _hoisted_12 = { key: 3 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Поле данных", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextControl = _resolveComponent("TextControl")!
  const _component_EnumControl = _resolveComponent("EnumControl")!
  const _component_DxTextBox = _resolveComponent("DxTextBox")!
  const _component_CatalogueSelectControl = _resolveComponent("CatalogueSelectControl")!
  const _component_CreateEditDialog = _resolveComponent("CreateEditDialog")!

  return (_openBlock(), _createBlock(_component_CreateEditDialog, {
    saveModelCallback: _ctx.saveModelCallback,
    ref: "dialog"
  }, {
    editForm: _withCtx(({ model, validationGroup }) => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createVNode(_component_TextControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "Наименование...",
          "show-clear-button": true,
          value: model.name,
          "onUpdate:value": ($event: any) => ((model.name) = $event),
          hasEmptyValue: false,
          validationGroup: validationGroup
        }, null, 8, ["value", "onUpdate:value", "validationGroup"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass({
              'col-6 ModelField-colFirst': _ctx.fieldDisplay,
              'col-12 ModelField-colSingle': !_ctx.fieldDisplay,
            })
          }, [
            _hoisted_4,
            _createVNode(_component_EnumControl, {
              class: "ModelField-control",
              id: model.type,
              "onUpdate:id": ($event: any) => ((model.type) = $event),
              desc: model.typeDescription,
              "onUpdate:desc": ($event: any) => ((model.typeDescription) = $event),
              enumType: "featureType",
              stylingMode: "outlined",
              hasEmptyValue: false,
              validationGroup: validationGroup
            }, null, 8, ["id", "onUpdate:id", "desc", "onUpdate:desc", "validationGroup"])
          ], 2),
          _createElementVNode("div", _hoisted_5, [
            (model.type == _ctx.FeatureType.Enum)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_DxTextBox, {
                    class: "ModelField-control",
                    stylingMode: "outlined",
                    placeholder: "Перечисление...",
                    "show-clear-button": true,
                    value: model.enumName,
                    "onUpdate:value": ($event: any) => ((model.enumName) = $event)
                  }, null, 8, ["value", "onUpdate:value"])
                ]))
              : _createCommentVNode("", true),
            (model.type == _ctx.FeatureType.DCatalogue)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_CatalogueSelectControl, {
                    class: "ModelField-selectControl",
                    stylingMode: "outlined",
                    id: model.dCatalogueId,
                    "onUpdate:id": ($event: any) => ((model.dCatalogueId) = $event),
                    desc: model.dCatalogueDescription,
                    "onUpdate:desc": ($event: any) => ((model.dCatalogueDescription) = $event),
                    displayDescField: "name",
                    keyField: "id",
                    catalogueComponentName: "catalogues/DCatalogueCatalogue/DCatalogueCatalogue",
                    hasEmptyValue: true,
                    validationGroup: validationGroup
                  }, null, 8, ["id", "onUpdate:id", "desc", "onUpdate:desc", "validationGroup"])
                ]))
              : _createCommentVNode("", true),
            (model.type == _ctx.FeatureType.Catalogue)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_DxTextBox, {
                    class: "ModelField-control",
                    stylingMode: "outlined",
                    placeholder: "Справочник...",
                    "show-clear-button": true,
                    value: model.catalogueName,
                    "onUpdate:value": ($event: any) => ((model.catalogueName) = $event)
                  }, null, 8, ["value", "onUpdate:value"])
                ]))
              : _createCommentVNode("", true),
            (model.type == _ctx.FeatureType.DataField)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_DxTextBox, {
                    class: "ModelField-control",
                    stylingMode: "outlined",
                    placeholder: "Поле данных...",
                    "show-clear-button": true,
                    value: model.dataFieldName,
                    "onUpdate:value": ($event: any) => ((model.dataFieldName) = $event)
                  }, null, 8, ["value", "onUpdate:value"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["saveModelCallback"]))
}